import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AppApis } from '@app/core/APIs/app-apis';
import type {
  WorkflowDraftDryRunRequest,
  WorkflowDraftDryRunResult,
} from './workflow-draft-dry-run.models';

@Injectable({ providedIn: 'root' })
export class WorkflowDraftDryRunService {
  private readonly http = inject(HttpClient);
  private readonly apis = inject(AppApis);

  simulate(draftId: number, eTag: string, request: WorkflowDraftDryRunRequest) {
    // This endpoint only evaluates a synthetic transcript. Never use a runtime command adapter to submit it.
    return this.http.post<WorkflowDraftDryRunResult>(
      this.apis.core.manual.getPlatformWorkflowDefinitionDraft(draftId) +
        '/simulate',
      request,
      {
        withCredentials: true,
        headers: new HttpHeaders({
          'If-Match': eTag,
          'skip-error-interceptor': 'yes',
          'skip-loading-interceptor': 'yes',
        }),
      },
    );
  }
}
